import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import PageSection from '~/src/features/domru-tv/packages/components/PageSection';
import TvPackageCard from '~/src/features/domru-tv/packages/components/TvPackageCard';
import { ITvPackage } from '~/src/store/reducers/tvPackages';
import { selectPackagesThemes } from '~/src/store/selectors/tvPackages';

import { ContentCarousel, LayoutSection } from './styled';

interface IProps {
    isHideActive: boolean,
    setConnectedItemsQuantity: Dispatch<SetStateAction<number>>,
}

const TvPackagesDetails = ({ isHideActive, setConnectedItemsQuantity }: IProps) => {
    const tvPackagesThemes = useSelector(selectPackagesThemes);

    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);
    const isTablet = useMatchMedia(`(max-width: ${wideBreakpoints.tablet})`);

    const { connectedItemsQuantity, currentItems } = useMemo(() => {
        const connectedItems = new Set();

        const unconnectedItems = tvPackagesThemes?.map(item => {
            const unconnectedPackets: ITvPackage[] = [];
            item.packets.forEach(packet => packet.active ? connectedItems.add(packet) : unconnectedPackets.push(packet));
            return {
                ...item,
                packets: unconnectedPackets,
            };
        });

        return {
            connectedItemsQuantity: connectedItems.size,
            currentItems: isHideActive ? unconnectedItems : tvPackagesThemes,
        };
    }, [isHideActive, tvPackagesThemes]);

    useEffect(() => {
        setConnectedItemsQuantity(connectedItemsQuantity);
    }, [connectedItemsQuantity, setConnectedItemsQuantity]);

    return (
        <>
            {currentItems?.map(item => {
                const { id, title, packets } = item;

                if (!packets.length) {
                    return null;
                }

                return (
                    <LayoutSection key={id}>
                        <PageSection.Title>{title}</PageSection.Title>
                        <PageSection.Content>
                            <ContentCarousel
                                withoutDots={!isTablet}
                                withoutArrows={isTablet}
                                slideWidth={352}
                                cellSpacing={isMobile ? 8 : 32}
                                initialSlideHeight={352}
                            >
                                {packets.map(packet => (
                                    <TvPackageCard
                                        key={packet.id}
                                        tvPacket={packet}
                                    />
                                ))}
                            </ContentCarousel>
                        </PageSection.Content>
                    </LayoutSection>
                );
            })}
        </>
    );
};

export default TvPackagesDetails;
